import { useCallback, useState, type FormEvent } from 'react';
import { Button } from '@/components/Button';
import { Form } from '@/components/Form';
import { TextField } from '@/components/TextField';
import { ButtonVariant } from '@/constants';
import { useDataLayer } from '@/hooks/useDataLayer';
import { useAddDiscountCode } from './useAddDiscountCode';
import * as Styled from './DiscountCodeEntry.styled';

export const DiscountCodeEntry = () => {
  const [errors, setErrors] = useState({});
  const { addDiscountCode: trackDiscountCode } = useDataLayer();

  const [discountCode, setDiscountCode] = useState('');
  const clearDiscountCode = () => setDiscountCode('');

  // Create tracking callback that will be called on successful discount code application
  const handleTrackingCallback = useCallback(
    (code: string) => {
      trackDiscountCode(code);
    },
    [trackDiscountCode],
  );

  const { addDiscountCode, isPending } = useAddDiscountCode(
    clearDiscountCode,
    setErrors,
    handleTrackingCallback,
  );

  const handleSubmit = useCallback(
    (e: FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      if (!isPending) {
        addDiscountCode({ discountCode });
      }
    },
    [addDiscountCode, discountCode, isPending],
  );

  return (
    <Styled.Wrapper>
      <Form
        handleSubmit={handleSubmit}
        orientation="inline"
        withLabels={true}
        validationErrors={errors}
      >
        <TextField
          isRequired
          label="Discount code"
          name="discountCode"
          onChange={setDiscountCode}
          type="text"
          value={discountCode}
          width={280}
        />
        <Button
          isPending={isPending}
          type="submit"
          variant={ButtonVariant.Secondary}
        >
          Apply
        </Button>
      </Form>
    </Styled.Wrapper>
  );
};
